
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applicant/[pageSlug]",
      function () {
        return require("private-next-pages/applicant/[pageSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applicant/[pageSlug]"])
      });
    }
  